
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#EE5151"}}),_c('path',{attrs:{"d":"M12.2298 12.1735L13 10.8495L10.9281 10L13 9.15816L12.2298 7.82653L10.4583 9.21939L10.7741 7H9.22593L9.53402 9.21939L7.77022 7.82653L7 9.15816L9.07189 10L7 10.8495L7.77022 12.1735L9.52632 10.8112L9.22593 13H10.7741L10.4737 10.8112L12.2298 12.1735Z","fill":"#fff"}})])
          )
        }
      }
    